export default __webpack_public_path__ + "static/media/downloadIcon.24555bd9.svg";